import { FormattedMessage } from 'react-intl'
import { Fragment } from 'react'
import useCurrentShop from '../hooks/useCurrentShop'

export default function Single({
  sharedHandler,
  setIsCollapsed,
  isApplySingle,
}) {
  const {
    shopInfo: { id },
  } = useCurrentShop()
  return (
    <Fragment>
      {isApplySingle && (
        <div>
          <FormattedMessage
            id='room_is_no_sharable'
            defaultMessage='The cabin you have selected only {doubleBed}is not shareable. By default, we have therefore applied the price for SINGLE OCCUPANCY. This means that you will have the cabin to yourself.'
            tagName='p'
            values={{
              doubleBed: id === '17034' ? '' : 'has a double bed and ', // By Silvia request
            }}
          />
          <FormattedMessage
            id='return_to_step_2_for_change_cabin'
            defaultMessage='If this is not what you wanted, please go back to step 2 and select a different cabin'
            tagName='p'
          />
        </div>
      )}
      {!isApplySingle && (
        <div className='buttons'>
          <button className='btn-red' onClick={() => sharedHandler(true)}>
            <FormattedMessage
              defaultMessage='Yes I want to share the cabin'
              id='want_to_share'
            />
          </button>
          <span onClick={() => setIsCollapsed(true)}>
            <FormattedMessage
              defaultMessage={`No thanks, I'm happy with single occupancy`}
              id='stay_with_single_occupancy'
            />
          </span>
        </div>
      )}
    </Fragment>
  )
}
